import BlockImagesTextTemplateGraphql from './BlockImagesTextTemplateGraphql';


export default {
  __name: 'BlockImagesTextStandardGraphql',
  props: {
  isPageAdvice: Boolean,
  title: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
  classes: {
    type: Object,
    default: () => {},
  },
  pictos: {
    type: Array,
    default: () => [],
  },
  backgroundWhite: {
    type: Boolean,
    default: false,
  },
  isOverlay: {
    type: Boolean,
    default: false,
  },
  bottomContent: {
    type: Boolean,
    default: false,
  },
  leafListOption: {
    type: Boolean,
    default: false,
  },
  isRecipePage: {
    type: Boolean,
    default: false,
  },
  isHomePage: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props, BlockImagesTextTemplateGraphql }
}

}